import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home/index.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        // title: 'common.home'
        title: 'Home',
        index: 1,
        keepAlive: true
      }
    },
    {
      path: '/thirdAuth',
      name: 'thirdAuth',
      component: () => import('./views/thirdAuth/index.vue'),
      meta: {
        title: 'Login',
        index: 1,
        keepAlive: false
      }
    },
    {
      path: '/productDetail',
      name: 'productDetail',
      component: () => import('./views/productDetail/index.vue'),
      meta: {
        title: 'Product Detail',
        index: 2,
        keepAlive: false
      }
    },
    {
      path: '/country',
      name: 'country',
      component: () => import('./views/country/index.vue'),
      meta: {
        title: 'Choose Country',
        index: 2,
        keepAlive: false
      }
    },
    {
      path: '/coupons',
      name: 'coupons',
      component: () => import('./views/coupons/index.vue'),
      meta: {
        title: 'My Pocket',
        index: 1,
        keepAlive: false
      }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: () => import('./views/orderDetail/index.vue'),
      meta: {
        title: 'Order Details',
        index: 6,
        keepAlive: false
      }
    },
    {
      path: '/couponDetail',
      name: 'couponDetail',
      component: () => import('./views/couponDetail/index.vue'),
      meta: {
        title: 'Coupon Details',
        index: 7,
        keepAlive: false
      }
    },
    {
      path: '/paymentResult',
      name: 'paymentResult',
      component: () => import('./views/paymentResult/index.vue'),
      meta: {
        title: 'Successful Payment',
        index: 7,
        keepAlive: false
        // title: 'Pay Fail'
      }
    },
    {
      path: '/applicableStores',
      name: 'applicableStores',
      component: () => import('./views/applicableStores/index.vue'),
      meta: {
        title: 'Applicable Stores',
        index: 8,
        keepAlive: false
      }
    },
    {
      path: '/buyGiftCard',
      name: 'buyGiftCard',
      component: () => import('./views/buyGiftCard/index.vue'),
      meta: {
        title: 'Select Product',
        index: 8,
        keepAlive: false
      }
    },
    {
      path: '/changeCardFace',
      name: 'changeCardFace',
      component: () => import('./views/changeCardFace/index.vue'),
      meta: {
        title: 'Choose Card',
        index: 8,
        keepAlive: false
      }
    },
    {
      path: '/brandGoods',
      name: 'brandGoods',
      component: () => import('./views/brandGoods/index.vue'),
      meta: {
        title: 'Select Product',
        index: 2,
        keepAlive: false
      }
    },
    {
      path: '/giveFriends',
      name: 'giveFriends',
      component: () => import('./views/giveFriends/index.vue'),
      meta: {
        title: 'Customised Gift',
        index: 8,
        keepAlive: false
      }
    },
    {
      path: '/myGiftCard',
      name: 'myGiftCard',
      component: () => import('./views/myGiftCard/index.vue'),
      meta: {
        title: 'My Pocket',
        index: 2,
        keepAlive: false
      }
    },
    {
      path: '/receiveGift',
      name: 'receiveGift',
      component: () => import('./views/receiveGift/index.vue'),
      meta: {
        title: '',
        index: 2,
        keepAlive: false
      }
    },
    {
      path: '/activity/shake',
      name: 'shake',
      component: () => import('./views/activity/shake/index.vue'),
      meta: {
        title: '',
        index: 2,
        keepAlive: false
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login/index.vue'),
      meta: {
        title: '',
        index: 1,
        keepAlive: false
      }
    },
    {
      path: '/logoutApp',
      name: 'logoutApp',
      component: () => import('./views/logoutApp/index.vue'),
      meta: {
        title: 'Logout',
        index: 1,
        keepAlive: false
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/register/index.vue'),
      meta: {
        title: 'Registration',
        index: 2,
        keepAlive: false
      }
    },
    {
      path: '/activity/rotaryTable',
      name: 'rotaryTable',
      component: () => import('./views/activity/rotaryTable/index.vue'),
      meta: {
        title: 'rotaryTable',
        index: 2,
        keepAlive: false
      }
    },
    {
      path: '/agreement',
      name: '',
      component: () => import('./views/agreement/index.vue'),
      meta: {
        title: '',
        index: 2,
        keepAlive: false
      }
    }
  ]
})
